export type Maybe<T> = T | null;

/** Key/value pairs to attach as additional metadata. Values are stored as strings. */
export interface CtgLoyaltyMetadataEntryInput {
  
  readonly key: string;
  
  readonly value: string;
}

export interface CustomerInput {
  
  readonly email: string;
  /** fdCustomerId */
  readonly id?: Maybe<string>;
  
  readonly name?: Maybe<string>;
}

export interface IsEmailInBounceListInput {
  
  readonly email: string;
}
/** Merge two prepaid gift cards into one. Source gets deleted. */
export interface PrepaidsMergeInput {
  /** Destination first data gift card Account ID gets balance from source */
  readonly destinationFdAccountId?: Maybe<string>;
  /** Customers email address */
  readonly email: string;
  /** Number of physical Gift Card which is the funding source (card being deactivated) */
  readonly sourceCardNumber: string;
  /** Pin number for physical gift card which is the funding source (card being deactivated) */
  readonly sourcePin?: Maybe<string>;
}
/** Replace an existing gift card with a new one. Original card gets deleted */
export interface PrepaidsReplaceInput {
  /** Customer's account region, an IsoCountryCode2Char */
  readonly region: string;
  /** The fdAccountId of the customer */
  readonly storedPaymentMethodId: string;
  /** Customer's id */
  readonly userId: string;
}

export interface RefundSaleInput {
  
  readonly customer: CustomerInput;
  /** Reason picked form a predefined dropdown list */
  readonly primaryReason: RefundReason;
  
  readonly rbiOrderId: string;
  
  readonly refundedItems?: Maybe<ReadonlyArray<Maybe<RefundedItemsInput>>>;
  /** Refund amount requested by customer */
  readonly requestedAmountCents?: Maybe<number>;
  /** Reason manually added by an admin */
  readonly secondaryReason?: Maybe<string>;
}

export interface RefundedItemsInput {
  
  readonly bkpn?: Maybe<string>;
  
  readonly name?: Maybe<string>;
  
  readonly parentName?: Maybe<string>;
  
  readonly parentSanityId?: Maybe<string>;
  
  readonly refundAmount?: Maybe<string>;
  
  readonly refundQuantity?: Maybe<string>;
  
  readonly refundSubtotalCents?: Maybe<number>;
  
  readonly refundTaxCents?: Maybe<number>;
  
  readonly remediationId?: Maybe<string>;
  
  readonly sanityId?: Maybe<string>;
  
  readonly type?: Maybe<CartEntryType>;
}

export interface RemoveEmailFromBounceListIfExistInput {
  
  readonly email: string;
}

export interface UpdateCommunicationPreferencesInput {
  
  readonly communicationPreferenceType: string;
  
  readonly customerId: string;
  
  readonly newStatus: boolean;
  
  readonly region: string;
}

  export enum Brand {
    BK = "BK",
    FHS = "FHS",
    PLK = "PLK",
  }

  export enum CartEntryType {
    COMBO = "Combo",
    COMBOSLOT = "ComboSlot",
    ITEM = "Item",
    ITEMOPTION = "ItemOption",
    ITEMOPTIONMODIFIER = "ItemOptionModifier",
    OFFERCOMBO = "OfferCombo",
    OFFERDISCOUNT = "OfferDiscount",
    OFFERITEM = "OfferItem",
  }

  export enum CateringDeclineReasons {
    CATERING_ORDER_TIME_OUT = "CATERING_ORDER_TIME_OUT",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    INVENTORY = "INVENTORY",
    STAFFING = "STAFFING",
    TIMING = "TIMING",
  }

  export enum CountryCode {
    CA = "CA",
    US = "US",
  }

  export enum DeliveryStatus {
    DRIVER_ASSIGNED = "DRIVER_ASSIGNED",
    DRIVER_AT_CUSTOMER = "DRIVER_AT_CUSTOMER",
    DRIVER_AT_STORE = "DRIVER_AT_STORE",
    DRIVER_STARTING = "DRIVER_STARTING",
    DRIVER_UNASSIGNED = "DRIVER_UNASSIGNED",
    ORDER_ABANDONED = "ORDER_ABANDONED",
    ORDER_CANCELLED = "ORDER_CANCELLED",
    ORDER_CREATED = "ORDER_CREATED",
    ORDER_DROPPED_OFF = "ORDER_DROPPED_OFF",
    ORDER_ERROR = "ORDER_ERROR",
    ORDER_PICKED_UP = "ORDER_PICKED_UP",
    ORDER_TIMEOUT = "ORDER_TIMEOUT",
    QUOTE_ERROR = "QUOTE_ERROR",
    QUOTE_REQUESTED = "QUOTE_REQUESTED",
    QUOTE_SUCCESSFUL = "QUOTE_SUCCESSFUL",
    QUOTE_UNAVAILABLE = "QUOTE_UNAVAILABLE",
  }

  export enum M2MScope {
    CA_ADMIN = "CA_ADMIN",
    CUSTOMER_CREATE = "CUSTOMER_CREATE",
    CUSTOMER_READ = "CUSTOMER_READ",
    CUSTOMER_UPDATE = "CUSTOMER_UPDATE",
    DSAR_READ = "DSAR_READ",
    GIFT_CARD_READ = "GIFT_CARD_READ",
    GIFT_CARD_UPDATE = "GIFT_CARD_UPDATE",
    LAUNCH_DARKLY_READ = "LAUNCH_DARKLY_READ",
    LOYALTY_CREATE_PERSONALIZED_OFFER = "LOYALTY_CREATE_PERSONALIZED_OFFER",
    LOYALTY_DEDUCT_POINTS = "LOYALTY_DEDUCT_POINTS",
    LOYALTY_ISSUE_POINTS = "LOYALTY_ISSUE_POINTS",
    LOYALTY_MANAGE_PARTNERSHIP = "LOYALTY_MANAGE_PARTNERSHIP",
    LOYALTY_MANAGE_SECONDARY_IDENTIFIERS = "LOYALTY_MANAGE_SECONDARY_IDENTIFIERS",
    LOYALTY_READ_OFFERS = "LOYALTY_READ_OFFERS",
    LOYALTY_READ_QUESTS = "LOYALTY_READ_QUESTS",
    LOYALTY_READ_TRANSACTIONS = "LOYALTY_READ_TRANSACTIONS",
    LOYALTY_READ_USER_INFO = "LOYALTY_READ_USER_INFO",
    ORDERS_READ = "ORDERS_READ",
    ORDERS_REMEDIATE = "ORDERS_REMEDIATE",
    STORE_READ = "STORE_READ",
    US_ADMIN = "US_ADMIN",
  }

  export enum Platform {
    APP = "app",
    BITENINJA = "biteninja",
    DOORDASH = "doordash",
    GOOGLEFOODORDERING = "googleFoodOrdering",
    GRUBHUB = "grubhub",
    INTERNAL = "internal",
    KIOSK = "kiosk",
    MICROSOFT = "microsoft",
    SKIP = "skip",
    UBER = "uber",
    WAITR = "waitr",
    WEB = "web",
  }

  export enum PosVendor {
    BRINK = "BRINK",
    CARROLS = "CARROLS",
    NCR = "NCR",
    QDI = "QDI",
    QST = "QST",
    SICOM = "SICOM",
  }

  export enum RbiOrderPaymentStatus {
    AUTHORIZATION_ERROR = "AUTHORIZATION_ERROR",
    AUTHORIZATION_REQUESTED = "AUTHORIZATION_REQUESTED",
    AUTHORIZATION_SUCCESSFUL = "AUTHORIZATION_SUCCESSFUL",
    CANCEL_ERROR = "CANCEL_ERROR",
    CANCEL_REQUESTED = "CANCEL_REQUESTED",
    CANCEL_SUCCESSFUL = "CANCEL_SUCCESSFUL",
    CAPTURE_ERROR = "CAPTURE_ERROR",
    CAPTURE_REQUESTED = "CAPTURE_REQUESTED",
    CAPTURE_SUCCESSFUL = "CAPTURE_SUCCESSFUL",
    PAYMENT_ERROR = "PAYMENT_ERROR",
    PAYMENT_REQUESTED = "PAYMENT_REQUESTED",
    PAYMENT_REQUIRED = "PAYMENT_REQUIRED",
    PAYMENT_SUCCESSFUL = "PAYMENT_SUCCESSFUL",
    REFUND_ERROR = "REFUND_ERROR",
    REFUND_REQUESTED = "REFUND_REQUESTED",
    REFUND_SUCCESSFUL = "REFUND_SUCCESSFUL",
    VOID_ERROR = "VOID_ERROR",
    VOID_REQUESTED = "VOID_REQUESTED",
    VOID_SUCCESSFUL = "VOID_SUCCESSFUL",
  }

  export enum RbiOrderStatus {
    CATERING_DECLINED = "CATERING_DECLINED",
    CATERING_ERROR = "CATERING_ERROR",
    CATERING_PLACED = "CATERING_PLACED",
    CATERING_SUCCESSFUL = "CATERING_SUCCESSFUL",
    INSERT_ERROR = "INSERT_ERROR",
    INSERT_REQUESTED = "INSERT_REQUESTED",
    INSERT_SUCCESSFUL = "INSERT_SUCCESSFUL",
    KOUNT_DENIAL = "KOUNT_DENIAL",
    PAYMENT_ERROR = "PAYMENT_ERROR",
    PAYMENT_REQUESTED = "PAYMENT_REQUESTED",
    PAYMENT_REQUIRED = "PAYMENT_REQUIRED",
    PAYMENT_SUCCESSFUL = "PAYMENT_SUCCESSFUL",
    PRICE_ERROR = "PRICE_ERROR",
    PRICE_REQUESTED = "PRICE_REQUESTED",
    PRICE_SUCCESSFUL = "PRICE_SUCCESSFUL",
    REFUND_ERROR = "REFUND_ERROR",
    REFUND_REQUESTED = "REFUND_REQUESTED",
    REFUND_SUCCESSFUL = "REFUND_SUCCESSFUL",
    UPDATE_ERROR = "UPDATE_ERROR",
    UPDATE_REQUESTED = "UPDATE_REQUESTED",
    UPDATE_SUCCESSFUL = "UPDATE_SUCCESSFUL",
    VALIDATION_ERROR = "VALIDATION_ERROR",
  }

  export enum RefundReason {
    CATERING_ORDER_DECLINED = "CATERING_ORDER_DECLINED",
    CATERING_ORDER_ERROR = "CATERING_ORDER_ERROR",
    CATERING_ORDER_TIME_OUT = "CATERING_ORDER_TIME_OUT",
    CUSTOMER_OVERCHARGED = "CUSTOMER_OVERCHARGED",
    CUSTOMER_REQUESTED_CANCEL_ORDER = "CUSTOMER_REQUESTED_CANCEL_ORDER",
    FOOD_QUALITY_ISSUE = "FOOD_QUALITY_ISSUE",
    INCORRECT_CUSTOMIZATION = "INCORRECT_CUSTOMIZATION",
    ITEMS_OUT_OF_STOCK = "ITEMS_OUT_OF_STOCK",
    MISSING_OR_INCORRECT_ITEM = "MISSING_OR_INCORRECT_ITEM",
    MOBILE_ORDERING_TECHNICAL_ISSUE = "MOBILE_ORDERING_TECHNICAL_ISSUE",
    ORDER_ARRIVED_LATE = "ORDER_ARRIVED_LATE",
    ORDER_CANCELLED = "ORDER_CANCELLED",
    ORDER_COMMIT_ERROR = "ORDER_COMMIT_ERROR",
    ORDER_NEVER_ARRIVED = "ORDER_NEVER_ARRIVED",
    ORDER_WAS_DAMAGED = "ORDER_WAS_DAMAGED",
    OTHER_ADD_COMMENT = "OTHER_ADD_COMMENT",
    RECEIVED_INCORRECT_ORDER = "RECEIVED_INCORRECT_ORDER",
    RESTAURANT_CLOSED = "RESTAURANT_CLOSED",
    RESTAURANT_COULDNT_FIND_ORDER = "RESTAURANT_COULDNT_FIND_ORDER",
  }

  export enum ServiceMode {
    CATERING_DELIVERY = "CATERING_DELIVERY",
    CATERING_PICKUP = "CATERING_PICKUP",
    CURBSIDE = "CURBSIDE",
    DELIVERY = "DELIVERY",
    DRIVE_THRU = "DRIVE_THRU",
    EAT_IN = "EAT_IN",
    MOBILE_ORDER_DRIVE_THRU = "MOBILE_ORDER_DRIVE_THRU",
    TABLE_SERVICE = "TABLE_SERVICE",
    TAKEOUT = "TAKEOUT",
  }


export type Json = any;




// ====================================================
// Scalars
// ====================================================







// ====================================================
// Types
// ====================================================



export interface AdditionalReferenceIds {
  
  readonly id?: Maybe<string>;
  
  readonly type?: Maybe<string>;
}


export interface ApiMetadata {
  /** Pong! Simple health check. */
  readonly ping: string;
}


export interface AssignedCouponListResponse {
  /** The count of elements in the response. If this value is zero, there were no matching coupon tokens. */
  readonly count: number;
  /** A resume point for a subsequent call. If this value is undefined or null, there are no more coupons. Specify this value on a subsequent call to continue paginating through coupons. */
  readonly resumeAfter?: Maybe<string>;
  /** The set of coupon tokens retrieved. If this array is empty, there were no matching coupon tokens. */
  readonly tokens: ReadonlyArray<CouponToken>;
}


export interface AssignedOffers {
  
  readonly offers?: Maybe<ReadonlyArray<Maybe<Offer>>>;
  
  readonly resumeAfter?: Maybe<string>;
}


export interface Balance {
  
  readonly beginBalance?: Maybe<number>;
  
  readonly currentBalance?: Maybe<number>;
}


export interface BillingAddress {
  /** City */
  readonly locality?: Maybe<string>;
  /** Zip Code */
  readonly postalCode?: Maybe<string>;
  /** State */
  readonly region?: Maybe<string>;
  /** Street Address */
  readonly streetAddress?: Maybe<string>;
  /** Apt or Unit Number */
  readonly unitNumber?: Maybe<string>;
}


export interface CtgFulfillment {
  
  readonly type?: Maybe<string>;
}


export interface CtgIncentive {
  
  readonly id?: Maybe<string>;
  
  readonly metadata?: Maybe<Metadata>;
  
  readonly type?: Maybe<string>;
}


export interface CtgLoyaltyMetadataEntry {
  
  readonly key: string;
  
  readonly value: string;
}


export interface CtgLoyaltyOrderIdByTransactionId {
  
  readonly rbiOrderId?: Maybe<string>;
  
  readonly transactionId: string;
}


export interface CtgLoyaltyPersonalizedOffer {
  
  readonly configId: string;
  
  readonly createdAt?: Maybe<string>;
  
  readonly endDate?: Maybe<string>;
  
  readonly id: string;
  
  readonly loyaltyId: string;
  
  readonly metadataEntries: ReadonlyArray<CtgLoyaltyMetadataEntry>;
  
  readonly metadata?: Maybe<Metadata>;
  
  readonly name?: Maybe<string>;
  
  readonly sourceId: string;
}


export interface CtgLoyaltyPosVendor {
  
  readonly terminalId?: Maybe<string>;
  
  readonly transactionId?: Maybe<string>;
  
  readonly type?: Maybe<string>;
}


export interface CtgLoyaltyQuests {
  
  readonly completions?: Maybe<ReadonlyArray<Maybe<MdwEngineIQuestProgress>>>;
  
  readonly endDate: string;
  
  readonly id: string;
  
  readonly incentiveType?: Maybe<string>;
  
  readonly name: string;
  
  readonly progress?: Maybe<MdwEngineIQuestProgress>;
  
  readonly sourceType?: Maybe<string>;
  
  readonly startDate: string;
  
  readonly steps: ReadonlyArray<Maybe<MdwEngineIQuestStep>>;
  
  readonly type: string;
}


export interface CtgLoyaltySecondaryIdentifier {
  
  readonly createdAt?: Maybe<string>;
  
  readonly id?: Maybe<string>;
  
  readonly identifier?: Maybe<string>;
  
  readonly identifierType?: Maybe<string>;
  
  readonly identifierVerified?: Maybe<boolean>;
  
  readonly loyaltyId?: Maybe<string>;
  
  readonly updatedAt?: Maybe<string>;
}


export interface CtgLoyaltyTransaction {
  
  readonly additionalReferenceIds?: Maybe<ReadonlyArray<Maybe<AdditionalReferenceIds>>>;
  
  readonly bonusPointsEarned: number;
  
  readonly channel: string;
  
  readonly createdAt: string;
  
  readonly currency?: Maybe<string>;
  
  readonly id: string;
  
  readonly loyaltyId?: Maybe<string>;
  
  readonly metadata?: Maybe<Metadata>;
  
  readonly metadataEntries: ReadonlyArray<CtgLoyaltyMetadataEntry>;
  
  readonly pointsDeducted?: Maybe<number>;
  
  readonly pointsEarned: number;
  
  readonly pointsUsed: number;
  
  readonly rbiOrderId?: Maybe<string>;
  
  readonly rewardIds: ReadonlyArray<Maybe<string>>;
  
  readonly shortId: string;
  
  readonly status: string;
  
  readonly store?: Maybe<Store>;
  
  readonly storeId?: Maybe<string>;
  
  readonly total: number;
  
  readonly transactionDetails?: Maybe<CtgTransactionDetails>;
}


export interface CtgLoyaltyUser {
  
  readonly cognitoId?: Maybe<string>;
  
  readonly createdAt: string;
  
  readonly dateOfBirth?: Maybe<string>;
  
  readonly email: string;
  
  readonly id: string;
  
  readonly name?: Maybe<string>;
  
  readonly partners?: Maybe<ReadonlyArray<Maybe<MdwIEnginePartnerUserDetails>>>;
  
  readonly points: number;
  
  readonly secondaryIdentifiers?: Maybe<ReadonlyArray<Maybe<SecondaryIdentifier>>>;
  
  readonly supportPoints?: Maybe<number>;
  
  readonly supportPointsTransactions?: Maybe<number>;
  
  readonly transactions?: Maybe<ReadonlyArray<Maybe<CtgLoyaltyTransaction>>>;
}


export interface CtgLoyaltyWalmartUserUnlink {
  
  readonly success: boolean;
}


export interface CtgTransactionDetails {
  
  readonly fulfillment?: Maybe<CtgFulfillment>;
  
  readonly orders?: Maybe<ReadonlyArray<Maybe<TransactionOrders>>>;
  
  readonly payments?: Maybe<ReadonlyArray<Maybe<Payments>>>;
  
  readonly person?: Maybe<Person>;
  
  readonly posVendor?: Maybe<CtgLoyaltyPosVendor>;
  
  readonly promotions?: Maybe<ReadonlyArray<Maybe<CtgIncentive>>>;
}


export interface Cart {
  
  readonly brand: Brand;
  
  readonly cartEntries?: Maybe<ReadonlyArray<Maybe<CartEntries>>>;
  
  readonly customerName: string;
  
  readonly discounts?: Maybe<ReadonlyArray<Maybe<Discount>>>;
  
  readonly donations?: Maybe<ReadonlyArray<Maybe<Donation>>>;
  
  readonly feCountryCode?: Maybe<string>;
  
  readonly mpfOrderId?: Maybe<string>;
  
  readonly mpfTax?: Maybe<MpfTax>;
  
  readonly partnerOrderId?: Maybe<string>;
  
  readonly payment?: Maybe<Payment>;
  
  readonly platform?: Maybe<Platform>;
  
  readonly posVendor: PosVendor;
  
  readonly requestedAmountCents: number;
  
  readonly serviceMode: ServiceMode;
  
  readonly storeAddress?: Maybe<StoreAddress>;
  
  readonly storeDetails?: Maybe<StoreDetails>;
  
  readonly storeId: string;
  
  readonly storePosId?: Maybe<string>;
  
  readonly subTotalCents?: Maybe<number>;
  
  readonly subTotalPaidCents?: Maybe<number>;
  
  readonly taxCents?: Maybe<number>;
  
  readonly taxCentsFromPartner?: Maybe<number>;
  
  readonly taxPaidCents?: Maybe<number>;
  
  readonly ticketNumber?: Maybe<string>;
  
  readonly totalCents?: Maybe<number>;
  
  readonly totalCentsFromPartner?: Maybe<number>;
  
  readonly totalPaidCents?: Maybe<number>;
  /** CartEntry IDs marked as unavailable by the pricing response (Connector only for now) */
  readonly unavailableCartEntries?: Maybe<ReadonlyArray<Maybe<UnavailableCartEntry>>>;
  
  readonly userDetails?: Maybe<UserDetails>;
  
  readonly userId?: Maybe<string>;
}


export interface CartEntries {
  
  readonly children?: Maybe<ReadonlyArray<Maybe<CartEntries>>>;
  
  readonly image?: Maybe<string>;
  
  readonly lineId: string;
  
  readonly name?: Maybe<string>;
  
  readonly offerVendorConfigs?: Maybe<VendorConfigs>;
  
  readonly pickerSelections?: Maybe<string>;
  
  readonly plu?: Maybe<Plu>;
  
  readonly price?: Maybe<number>;
  
  readonly productHierarchy?: Maybe<ProductHierarchy>;
  
  readonly quantity: number;
  
  readonly redeemable?: Maybe<boolean>;
  
  readonly sanityId?: Maybe<string>;
  
  readonly type: CartEntryType;
  
  readonly url?: Maybe<string>;
  
  readonly vendorConfigs?: Maybe<VendorConfigs>;
}


export interface Catering {
  
  readonly declineReason?: Maybe<CateringDeclineReasons>;
  
  readonly notes?: Maybe<string>;
  
  readonly pickupTime: string;
}


export interface CommunicationPreferences {
  
  readonly marketingEmail?: Maybe<boolean>;
  
  readonly marketingPush?: Maybe<boolean>;
  
  readonly marketingSms?: Maybe<boolean>;
}


export interface ConfigIncentive {
  
  readonly loyaltyEngineId?: Maybe<string>;
}


export interface CouponToken {
  /** Brief description on the situation that caused coupon to be issued */
  readonly comments?: Maybe<string>;
  /** The coupon identity associated with the coupon token. */
  readonly couponId: string;
  /** The ISO-formatted timestamp of when the coupon token was created. */
  readonly createdAt: string;
  /** The ISO-formatted timestamp of when the coupon token expires. If the value is null, then the coupon token never expires. */
  readonly expiresOn?: Maybe<string>;
  /** A unique combination of pk and sk */
  readonly id: string;
  /** The name of the corresponsing offer in Sanity */
  readonly offerName?: Maybe<string>;
  /** The partition key, which is equal to userId. */
  readonly pk: string;
  /** Reason for issuing the coupon */
  readonly reason?: Maybe<string>;
  /** The id of order that was refunded */
  readonly refundedRbiOrderId?: Maybe<string>;
  /** The id of the support agent who issue'd this coupon */
  readonly supportCognitoId?: Maybe<string>;
  /** The email of the support agent who issue'd this coupon */
  readonly supportEmail?: Maybe<string>;
  /** The identity of the coupon token. */
  readonly tokenId: string;
  /** The identity of the user owning the coupon token. */
  readonly userId: string;
}


export interface CreditCard {
  /** Credit card last 4 digits */
  readonly alias: string;
  /** Billing address details */
  readonly billingAddress?: Maybe<BillingAddress>;
  /** Card type, e.g. 'Mastercard' */
  readonly cardType: string;
  /** Date created */
  readonly createdAt: string;
  /** Two digit expiry month */
  readonly expiryMonth: string;
  /** Two digit expiry year */
  readonly expiryYear: string;
}


export interface Customer {
  
  readonly cognitoId?: Maybe<string>;
  
  readonly orders?: Maybe<OrderListResponse>;
}


export interface CustomerDetails {
  
  readonly assignedOffers?: Maybe<AssignedOffers>;
  
  readonly communicationPreferences?: Maybe<CommunicationPreferences>;
  
  readonly couponRedemptions?: Maybe<RedeemedCouponListResponse>;
  
  readonly couponTokens?: Maybe<AssignedCouponListResponse>;
  
  readonly createdAt?: Maybe<string>;
  
  readonly creditCards?: Maybe<ReadonlyArray<Maybe<CreditCard>>>;
  
  readonly customerId?: Maybe<string>;
  
  readonly defaultFdAccountId?: Maybe<string>;
  
  readonly dob?: Maybe<string>;
  
  readonly email?: Maybe<string>;
  
  readonly fdCustomerId?: Maybe<string>;
  
  readonly isoCountryCode?: Maybe<string>;
  
  readonly loyaltyId?: Maybe<string>;
  
  readonly name?: Maybe<string>;
  
  readonly offersVersion?: Maybe<string>;
  
  readonly optedInLoyalty?: Maybe<boolean>;
  
  readonly orders?: Maybe<OrderListResponse>;
  
  readonly ordersByIds?: Maybe<OrderListResponse>;
  
  readonly phoneNumber?: Maybe<string>;
  
  readonly pointsRemediations?: Maybe<ReadonlyArray<Maybe<Remediation>>>;
  
  readonly prepaidCard?: Maybe<PrepaidCard>;
  
  readonly promotionalEmails?: Maybe<boolean>;
  
  readonly refundCounts?: Maybe<RefundCounts>;
  
  readonly remediationRate?: Maybe<RemediationRate>;
  
  readonly remediationReasons?: Maybe<ReadonlyArray<Maybe<RemediationReason>>>;
  
  readonly remediations?: Maybe<RemediationListResponse>;
  
  readonly secondaryIdentifiers?: Maybe<ReadonlyArray<Maybe<SecondaryIdentifier>>>;
  
  readonly supportOffers?: Maybe<ReadonlyArray<Maybe<SanityOffer>>>;
  
  readonly zipCode?: Maybe<string>;
}


export interface CustomerInfo {
  
  readonly details?: Maybe<CustomerDetails>;
}


export interface CustomerSignUpResult {
  
  readonly userConfirmed: boolean;
  
  readonly userSub: string;
}


export interface Day {
  
  readonly close?: Maybe<string>;
  
  readonly open?: Maybe<string>;
}


export interface DayPart {
  
  readonly displayName: string;
  
  readonly hours: StoreHours;
  
  readonly key: string;
}


export interface Delivery {
  
  readonly assignedFleetName?: Maybe<string>;
  
  readonly cancellation?: Maybe<DeliveryCancellation>;
  
  readonly deliveryImageUrl?: Maybe<string>;
  
  readonly driver?: Maybe<DeliveryDriver>;
  
  readonly dropoff?: Maybe<Dropoff>;
  
  readonly feeCents?: Maybe<number>;
  
  readonly feeDiscountCents?: Maybe<number>;
  
  readonly fleetId?: Maybe<string>;
  
  readonly status?: Maybe<DeliveryStatus>;
  
  readonly tipCents?: Maybe<number>;
}


export interface DeliveryCancellation {
  
  readonly category?: Maybe<string>;
  
  readonly details?: Maybe<string>;
  
  readonly id?: Maybe<number>;
  
  readonly reason?: Maybe<string>;
}


export interface DeliveryDriver {
  
  readonly driverId?: Maybe<string>;
  
  readonly driverName?: Maybe<string>;
  
  readonly phoneNumber?: Maybe<string>;
  
  readonly profileImageUrl?: Maybe<string>;
}


export interface Detail {
  
  readonly customer?: Maybe<UserDetails>;
  
  readonly summary: Summary;
}


export interface Discount {
  
  readonly name: string;
  
  readonly value: number;
}


export interface Donation {
  
  readonly id: string;
  
  readonly name: string;
  
  readonly totalCents: number;
}


export interface Dropoff {
  
  readonly addressLine1?: Maybe<string>;
  
  readonly addressLine2?: Maybe<string>;
  
  readonly beforeTime?: Maybe<string>;
  
  readonly city?: Maybe<string>;
  
  readonly state?: Maybe<string>;
  
  readonly zip?: Maybe<string>;
}


export interface DsarRequest {
  
  readonly _id?: Maybe<string>;
  
  readonly createdAt?: Maybe<string>;
  
  readonly onetrustRequestId?: Maybe<string>;
  
  readonly requestId?: Maybe<string>;
  
  readonly status?: Maybe<string>;
  
  readonly type?: Maybe<string>;
}


export interface DsarRequestsResponse {
  
  readonly nextPage?: Maybe<string>;
  
  readonly requests?: Maybe<ReadonlyArray<Maybe<DsarRequest>>>;
}


export interface ExternalIdentifiers {
  
  readonly type?: Maybe<string>;
  
  readonly value?: Maybe<string>;
}


export interface IPrepaidDetails {
  /** current balance on the gift card in cents */
  readonly balance?: Maybe<number>;
  /** card number on a gift card */
  readonly cardNumber?: Maybe<string>;
}


export interface IRestaurantAmenity {
  
  readonly name?: Maybe<IRestaurantAmenityName>;
}


export interface IRestaurantAmenityName {
  
  readonly _type?: Maybe<string>;
  
  readonly en?: Maybe<string>;
}


export interface IStoreHolidayHours {
  
  readonly close?: Maybe<string>;
  
  readonly date?: Maybe<string>;
  
  readonly holiday?: Maybe<string>;
  
  readonly open?: Maybe<string>;
}


export interface IsEmailInBounceListResponse {
  
  readonly isInBounceList: boolean;
}


export interface IssueCouponToUserResponse {
  /** The count of elements in the response. */
  readonly count: number;
  /** The set of coupon tokens retrieved. If this array is empty, there were no matching coupon tokens. */
  readonly tokens: ReadonlyArray<CouponToken>;
}


export interface LaunchDarklyFlagResponse {
  /** Value of the LaunchDarkly flag evaluated, i.e. whether it is on or off */
  readonly response?: Maybe<Json>;
}


export interface LoyaltyTransactionForOrder {
  
  readonly bonusPointsEarned?: Maybe<number>;
  
  readonly pointsBalance?: Maybe<number>;
  
  readonly pointsEarned?: Maybe<number>;
  
  readonly pointsUsed?: Maybe<number>;
  
  readonly rewardsUsed?: Maybe<number>;
}


export interface MdwEngineIQuestProgress {
  
  readonly activatedOn?: Maybe<string>;
  
  readonly steps?: Maybe<ReadonlyArray<Maybe<MdwEngineIQuestProgressStep>>>;
}


export interface MdwEngineIQuestProgressStep {
  
  readonly completedAt?: Maybe<string>;
  
  readonly stepId: string;
  
  readonly transaction?: Maybe<MdwEngineIQuestProgressStepTransaction>;
}


export interface MdwEngineIQuestProgressStepTransaction {
  
  readonly id: string;
}


export interface MdwEngineIQuestStep {
  
  readonly cartRequirements?: Maybe<ReadonlyArray<ReadonlyArray<Maybe<MdwEngineProductRequirementEntry>>>>;
  
  readonly id: string;
  
  readonly minimumSpend?: Maybe<string>;
}


export interface MdwEngineProductRequirementEntry {
  
  readonly id: string;
  
  readonly name?: Maybe<string>;
  
  readonly quantity: string;
}


export interface MdwIEnginePartnerUserDetails {
  
  readonly createdAt?: Maybe<string>;
  
  readonly id?: Maybe<string>;
  
  readonly name?: Maybe<string>;
  
  readonly partner?: Maybe<string>;
  
  readonly partnerData?: Maybe<MdwIEnginePartnerUserDetailsData>;
  
  readonly partnerUserId?: Maybe<string>;
  
  readonly status?: Maybe<string>;
  
  readonly updatedAt?: Maybe<string>;
}


export interface MdwIEnginePartnerUserDetailsData {
  
  readonly userState?: Maybe<string>;
}


export interface MenuArtifact {
  
  readonly bucketName: string;
  
  readonly exists: boolean;
  
  readonly key: string;
  
  readonly lastModified?: Maybe<string>;
  
  readonly source: string;
}

/** A Prepaid Merge two gift cards response */
export interface Merge {
  /** dollar amount destination gift card begins with */
  readonly beginBalance: number;
  /** destination card currency code */
  readonly currencyCode: string;
  /** new balance of destination gift card after merge in dollars */
  readonly currentBalance: number;
  /** card number of destination gift card */
  readonly destinationCardNumber: string;
  
  readonly fdCorrelationId?: Maybe<string>;
  /** card number of source gift card that was deleted */
  readonly sourceCardNumber: string;
  
  readonly transactionId: string;
}


export interface Metadata {
  
  readonly agentEmail?: Maybe<string>;
  
  readonly comments?: Maybe<string>;
  
  readonly createdAt?: Maybe<string>;
  
  readonly externalIdentifiers?: Maybe<ReadonlyArray<Maybe<ExternalIdentifiers>>>;
  
  readonly identifier?: Maybe<string>;
  
  readonly identifierType?: Maybe<string>;
  
  readonly maxTransactionLimitReached?: Maybe<boolean>;
  
  readonly name?: Maybe<string>;
  
  readonly orderId?: Maybe<string>;
  
  readonly remediationReason?: Maybe<string>;
  
  readonly source?: Maybe<string>;
}


export interface MpfTax {
  
  readonly isTaxRemittedByMpf?: Maybe<boolean>;
  
  readonly taxRemittedByMpfCents?: Maybe<number>;
}


export interface Mutation {
  
  readonly api?: Maybe<ApiMetadata>;
  
  readonly ctgLoyaltyCreatePersonalizedOffer?: Maybe<CtgLoyaltyPersonalizedOffer>;
  
  readonly ctgLoyaltyDeductPoints: number;
  
  readonly ctgLoyaltyIssuePoints: number;
  
  readonly ctgLoyaltyRemoveSecondaryIdentifier?: Maybe<CtgLoyaltySecondaryIdentifier>;
  
  readonly ctgLoyaltyWalmartUserUnlink?: Maybe<CtgLoyaltyWalmartUserUnlink>;
  /** sign up a new customer */
  readonly customerSignUp: CustomerSignUpResult;
  
  readonly issueCouponToUser: IssueCouponToUserResponse;
  /** Transfer balance of prepaid gift card into one and delete it */
  readonly prepaidsMerge: Merge;
  /** Replace prepaid gift card on a user and get rid of the old one */
  readonly prepaidsReplace: Replace;
  /** record a remediation with type RemediationType.NONE on an order */
  readonly recordNonRemediation?: Maybe<boolean>;
  /** Refund an order partially or fully */
  readonly refundSale: RefundSale;
  /** Remove an email address from braze bounce list if it is there */
  readonly removeEmailFromBounceListIfExist: RemoveEmailFromBounceListIfExistResponse;
  /** Update the communication preferences for a customer */
  readonly updateCommunicationPreferences?: Maybe<CommunicationPreferences>;
  /** update the date of birth on a user profile */
  readonly updateDob: UpdateDobResponse;
}


export interface Offer {
  
  readonly agentEmail?: Maybe<string>;
  
  readonly assignedDate?: Maybe<string>;
  
  readonly challengeGoals?: Maybe<string>;
  
  readonly challengeReward?: Maybe<string>;
  
  readonly comments?: Maybe<string>;
  
  readonly couponId?: Maybe<string>;
  
  readonly expiryDate?: Maybe<string>;
  
  readonly id: string;
  
  readonly isActive?: Maybe<boolean>;
  
  readonly loyaltyEngineId?: Maybe<string>;
  
  readonly name?: Maybe<string>;
  
  readonly offerTemplateId?: Maybe<string>;
  
  readonly rbiOrderId?: Maybe<string>;
  
  readonly reason?: Maybe<string>;
  
  readonly redemptionDate?: Maybe<string>;
  
  readonly redemptionSteps?: Maybe<ReadonlyArray<Maybe<string>>>;
  
  readonly terms?: Maybe<string>;
  
  readonly tokenId?: Maybe<string>;
}


export interface OfferAssignedResponse {
  
  readonly succeeded: boolean;
}


export interface Order {
  
  readonly cart: Cart;
  
  readonly catering?: Maybe<Catering>;
  
  readonly createdAt: string;
  
  readonly customer?: Maybe<CustomerDetails>;
  
  readonly delivery?: Maybe<Delivery>;
  
  readonly fireOrderIn?: Maybe<number>;
  
  readonly loyaltyTransaction?: Maybe<LoyaltyTransactionForOrder>;
  
  readonly order?: Maybe<RbiOrder>;
  
  readonly paymentAuditEvent?: Maybe<PaymentAuditEvent>;
  
  readonly paymentStatus?: Maybe<RbiOrderPaymentStatus>;
  
  readonly paymentVersion?: Maybe<number>;
  
  readonly pickupDetails?: Maybe<Json>;
  
  readonly pk: string;
  
  readonly posOrderId?: Maybe<string>;
  
  readonly posVendor: string;
  
  readonly rbiOrderId: string;
  
  readonly refund?: Maybe<RefundDetails>;
  
  readonly remediations?: Maybe<ReadonlyArray<Maybe<Remediation>>>;
  
  readonly revision: number;
  
  readonly revisions?: Maybe<ReadonlyArray<Maybe<Order>>>;
  
  readonly sk: string;
  
  readonly status: RbiOrderStatus;
  
  readonly updatedAt: string;
  
  readonly userId?: Maybe<string>;
}


export interface OrderListResponse {
  
  readonly count: number;
  
  readonly orders?: Maybe<ReadonlyArray<Maybe<Order>>>;
  
  readonly resumeAfter?: Maybe<string>;
}


export interface ParentChildPlu {
  
  readonly childPlu: string;
  
  readonly plu: string;
}


export interface Payment {
  
  readonly cardType?: Maybe<string>;
  
  readonly ccExpiryMonth?: Maybe<string>;
  
  readonly ccExpiryYear?: Maybe<string>;
  
  readonly ccLast4?: Maybe<string>;
  
  readonly fdCorrelationId?: Maybe<string>;
  
  readonly fdCustomerId?: Maybe<string>;
  
  readonly fdSaleId?: Maybe<string>;
}


export interface PaymentAuditEvent {
  
  readonly auditLogId?: Maybe<string>;
  
  readonly context?: Maybe<PaymentAuditEventContext>;
  
  readonly createdAt?: Maybe<string>;
  
  readonly eventId?: Maybe<string>;
  
  readonly userId?: Maybe<string>;
}


export interface PaymentAuditEventContext {
  
  readonly amountCents?: Maybe<number>;
  
  readonly currency?: Maybe<string>;
  
  readonly failureReason?: Maybe<string>;
  
  readonly fdSaleId?: Maybe<string>;
  
  readonly isSuccessful?: Maybe<boolean>;
  
  readonly prepaid?: Maybe<PrepaidCardContext>;
  
  readonly transactionId?: Maybe<string>;
  
  readonly type?: Maybe<string>;
}


export interface Payments {
  
  readonly amount?: Maybe<string>;
  
  readonly type?: Maybe<string>;
}


export interface Person {
  
  readonly currentPoints?: Maybe<string>;
}


export interface Plu {
  
  readonly connector?: Maybe<string>;
  
  readonly ncr?: Maybe<string>;
  
  readonly ncrDelivery?: Maybe<string>;
  
  readonly productNumber?: Maybe<string>;
  
  readonly qst?: Maybe<string>;
  
  readonly sicom?: Maybe<string>;
  
  readonly sicomDelivery?: Maybe<string>;
}


export interface PluDocument {
  
  readonly name?: Maybe<string>;
}


export interface PrepaidAccounts {
  
  readonly customer?: Maybe<UserDetails>;
  
  readonly prepaidAccounts?: Maybe<ReadonlyArray<Maybe<PrepaidCard>>>;
}


export interface PrepaidCard {
  /** gift card last 4 digits */
  readonly alias: string;
  
  readonly beginBalance?: Maybe<number>;
  /** Gift card number */
  readonly cardNumber?: Maybe<string>;
  /** dollar amount gift card begins with */
  readonly currencyCode: string;
  /** current gift card balance in cents */
  readonly currentBalance: number;
  /** Two digit expiry month */
  readonly expiryMonth: string;
  /** Two digit expiry year */
  readonly expiryYear: string;
  
  readonly fdAccountId?: Maybe<string>;
  /** ISO Country code */
  readonly isoCountryCode?: Maybe<string>;
  /** First Data prepaid status */
  readonly status?: Maybe<string>;
  /** Card transactions */
  readonly transactions?: Maybe<ReadonlyArray<Maybe<Transaction>>>;
}


export interface PrepaidCardContext {
  
  readonly balance?: Maybe<Balance>;
}


export interface ProductHierarchy {
  
  readonly L1?: Maybe<string>;
  
  readonly L2?: Maybe<string>;
  
  readonly L3?: Maybe<string>;
  
  readonly L4?: Maybe<string>;
  
  readonly L5?: Maybe<string>;
}


export interface QuantityPlu {
  
  readonly plu: string;
  
  readonly qualifier?: Maybe<string>;
  
  readonly quantity: number;
}


export interface Query {
  /** Look up Customer by email or customerId */
  readonly Customer?: Maybe<CustomerDetails>;
  /** Query whether a customer is seeing the feature flag based on their cognitoId and country */
  readonly LaunchDarklyFlag: LaunchDarklyFlagResponse;
  /** Query an order by order id */
  readonly Order?: Maybe<Order>;
  /** API Metadata */
  readonly api?: Maybe<ApiMetadata>;
  
  readonly ctgLoyaltyIdByEmail?: Maybe<string>;
  
  readonly ctgLoyaltyOffersByLoyaltyId?: Maybe<ReadonlyArray<Maybe<CtgLoyaltyPersonalizedOffer>>>;
  
  readonly ctgLoyaltyQuestsByLoyaltyId?: Maybe<ReadonlyArray<Maybe<CtgLoyaltyQuests>>>;
  
  readonly ctgLoyaltyTransaction?: Maybe<CtgLoyaltyTransaction>;
  
  readonly ctgLoyaltyTransactionById?: Maybe<CtgLoyaltyTransaction>;
  
  readonly ctgLoyaltyTransactions?: Maybe<ReadonlyArray<Maybe<CtgLoyaltyTransaction>>>;
  
  readonly ctgLoyaltyUserById?: Maybe<CtgLoyaltyUser>;
  
  readonly ctgRbiOrderIdsByTransactionIds?: Maybe<ReadonlyArray<Maybe<CtgLoyaltyOrderIdByTransactionId>>>;
  /** Look up Customer by their email address */
  readonly customerByEmail?: Maybe<CustomerInfo>;
  /** Look up Customer by device ID */
  readonly customersByDeviceId: ReadonlyArray<CustomerDetails>;
  /** Query a store by store id */
  readonly dsarRequest?: Maybe<DsarRequest>;
  
  readonly dsarRequests?: Maybe<DsarRequestsResponse>;
  /** Check if an email is in the Braze's hard bounced list */
  readonly isEmailInBounceList: IsEmailInBounceListResponse;
  /** Get list of orders by a customer's email */
  readonly orders: OrderListResponse;
  
  readonly prepaidByCardNumber?: Maybe<PrepaidCard>;
  
  readonly prepaidByCustomer?: Maybe<PrepaidAccounts>;
  
  readonly prepaidDetail?: Maybe<Detail>;
  /** Query a giftcard by userId, giftcard #, rbiOrderId */
  readonly prepaidSummary?: Maybe<Summary>;
  /** Query a store by store id */
  readonly store?: Maybe<Store>;
  /** Get S3 file metadata for store menu artifacts */
  readonly storeMenuArtifactsMetadata?: Maybe<ReadonlyArray<Maybe<MenuArtifact>>>;
  
  readonly stores?: Maybe<ReadonlyArray<Maybe<Store>>>;
}


export interface RbiOrder {
  
  readonly currency?: Maybe<string>;
  
  readonly refund?: Maybe<RefundDetails>;
}


export interface RedeemedCoupon {
  /** The initial date that the token was assigned */
  readonly assignedAt?: Maybe<string>;
  /** The coupon identity associated with the coupon token. */
  readonly couponId: string;
  /** The ISO-formatted timestamp of when the coupon token was created. */
  readonly createdAt: string;
  /** A unique combination of pk and sk */
  readonly id: string;
  /** The name of the corresponsing offer in Sanity */
  readonly offerName?: Maybe<string>;
  /** The partition key, which is equal to userId. */
  readonly pk: string;
  /** Id for the order that the refund is being redeemed for */
  readonly rbiOrderId?: Maybe<string>;
  /** Date of redemption */
  readonly redeemedOn?: Maybe<string>;
  /** The id of order that was refunded */
  readonly refundedRbiOrderId?: Maybe<string>;
  /** The id of the support agent who issue'd this coupon */
  readonly supportCognitoId?: Maybe<string>;
  /** The email of the support agent who issue'd this coupon */
  readonly supportEmail?: Maybe<string>;
  /** The identity of the coupon token. */
  readonly tokenId?: Maybe<string>;
  /** The identity of the user owning the coupon token. */
  readonly userId: string;
}


export interface RedeemedCouponListResponse {
  /** The count of elements in the response. If this value is zero, there were no matching coupon tokens. */
  readonly count: number;
  /** The set of redeemed coupons retrieved. If this array is empty, there were redeemed coupons for this user. */
  readonly redemptions: ReadonlyArray<RedeemedCoupon>;
  /** A resume point for a subsequent call. If this value is undefined or null, there are no more coupons. Specify this value on a subsequent call to continue paginating through coupons. */
  readonly resumeAfter?: Maybe<string>;
}


export interface RefundCounts {
  
  readonly autoRefundable?: Maybe<boolean>;
  
  readonly fullRefunds?: Maybe<number>;
  
  readonly ordersForRefundPercentage?: Maybe<number>;
  
  readonly partialRefunds?: Maybe<number>;
}


export interface RefundDetails {
  /** Admin user who issued the refund */
  readonly adminUserEmail: string;
  
  readonly approvedAmount: string;
  /** Reason picked from a predefined dropdown list */
  readonly primaryReason: RefundReason;
  
  readonly refundMethod?: Maybe<string>;
  
  readonly refundedItems?: Maybe<ReadonlyArray<Maybe<RefundedItem>>>;
  /** Optional reason manually added by an admin */
  readonly secondaryReason?: Maybe<string>;
  
  readonly subtotal: string;
  
  readonly tax: string;
  /** Date time when refund was issued */
  readonly transactionDateTime: string;
}


export interface RefundSale {
  
  readonly msgSentToQueue?: Maybe<boolean>;
}


export interface RefundedItem {
  
  readonly bkpn?: Maybe<string>;
  
  readonly name?: Maybe<string>;
  
  readonly parentName?: Maybe<string>;
  
  readonly parentSanityId?: Maybe<string>;
  
  readonly plu: Plu;
  
  readonly refundAmount?: Maybe<string>;
  
  readonly refundQuantity?: Maybe<string>;
  
  readonly remediationId?: Maybe<string>;
  
  readonly sanityId?: Maybe<string>;
  
  readonly type?: Maybe<CartEntryType>;
}


export interface Remediation {
  
  readonly amount?: Maybe<number>;
  
  readonly created: string;
  
  readonly displayName: string;
  
  readonly remediationComments?: Maybe<string>;
  
  readonly remediationReason?: Maybe<string>;
  
  readonly remediationType: string;
  
  readonly sanityId?: Maybe<string>;
  
  readonly secondaryTransactionId?: Maybe<string>;
  
  readonly secondaryTransactionType?: Maybe<string>;
  
  readonly supportEmail: string;
  
  readonly transactionId?: Maybe<string>;
  
  readonly transactionType?: Maybe<string>;
  
  readonly userId: string;
}


export interface RemediationListResponse {
  
  readonly remediations: ReadonlyArray<Maybe<Remediation>>;
  
  readonly resumeAfter?: Maybe<string>;
}


export interface RemediationRate {
  
  readonly endDate: string;
  
  readonly rate: number;
  
  readonly startDate: string;
  
  readonly totalOffersV1: number;
  
  readonly totalOffersV2: number;
  
  readonly totalOrders: number;
  
  readonly totalPoints: number;
  
  readonly totalRefunds: number;
  
  readonly totalRemediations: number;
}


export interface RemediationReason {
  
  readonly label?: Maybe<string>;
  
  readonly value?: Maybe<string>;
}


export interface RemoveEmailFromBounceListIfExistResponse {
  
  readonly messsage: string;
}

/** A Prepaid Replace gift card response */
export interface Replace {
  /** information about a prepaid card */
  readonly prepaid?: Maybe<IPrepaidDetails>;
}


export interface ResetOtpResponse {
  
  readonly succeeded: boolean;
}


export interface SanityOffer {
  
  readonly _id: string;
  
  readonly _type: string;
  
  readonly configIncentive?: Maybe<ConfigIncentive>;
  
  readonly loyaltyEngineId?: Maybe<string>;
  
  readonly monetaryValueCents: number;
  
  readonly name?: Maybe<string>;
}


export interface SanityStoreAddress {
  
  readonly address1?: Maybe<string>;
  
  readonly address2?: Maybe<string>;
  
  readonly city?: Maybe<string>;
  
  readonly country?: Maybe<string>;
  
  readonly postalCode?: Maybe<string>;
  
  readonly state?: Maybe<string>;
  
  readonly stateProvince?: Maybe<string>;
  
  readonly stateProvinceShort?: Maybe<string>;
}


export interface SecondaryIdentifier {
  
  readonly identifier?: Maybe<string>;
  
  readonly identifierType?: Maybe<string>;
}


export interface SizeBasedPlu {
  
  readonly comboPlu: string;
  
  readonly comboSize: string;
}


export interface StatusesApp {
  
  readonly notes?: Maybe<string>;
  
  readonly reason?: Maybe<string>;
  
  readonly status: string;
}


export interface Store {
  
  readonly _id: string;
  
  readonly amenities?: Maybe<ReadonlyArray<Maybe<IRestaurantAmenity>>>;
  
  readonly curbsideHolidayHours?: Maybe<ReadonlyArray<Maybe<IStoreHolidayHours>>>;
  
  readonly curbsideHours?: Maybe<StoreHours>;
  
  readonly dayParts?: Maybe<ReadonlyArray<Maybe<DayPart>>>;
  
  readonly deliveryHolidayHours?: Maybe<ReadonlyArray<Maybe<IStoreHolidayHours>>>;
  
  readonly deliveryHours?: Maybe<StoreHours>;
  
  readonly diningRoomHolidayHours?: Maybe<ReadonlyArray<Maybe<IStoreHolidayHours>>>;
  
  readonly diningRoomHours?: Maybe<StoreHours>;
  
  readonly driveThruHolidayHours?: Maybe<ReadonlyArray<Maybe<IStoreHolidayHours>>>;
  
  readonly driveThruHours?: Maybe<StoreHours>;
  
  readonly franchiseGroupId?: Maybe<number>;
  
  readonly franchiseGroupName?: Maybe<string>;
  
  readonly hasCatering?: Maybe<boolean>;
  
  readonly hasCurbside?: Maybe<boolean>;
  
  readonly hasDelivery?: Maybe<boolean>;
  
  readonly hasDineIn?: Maybe<boolean>;
  
  readonly hasDriveThru?: Maybe<boolean>;
  
  readonly hasMobileOrdering?: Maybe<boolean>;
  
  readonly hasTakeOut?: Maybe<boolean>;
  /** Last date time when the store made an order */
  readonly lastActiveDateTime?: Maybe<string>;
  
  readonly latitude?: Maybe<number>;
  
  readonly longitude?: Maybe<number>;
  
  readonly mobileOrderingStatus?: Maybe<string>;
  
  readonly phoneNumber?: Maybe<string>;
  
  readonly posVendor?: Maybe<string>;
  
  readonly status?: Maybe<string>;
  
  readonly storeAddress?: Maybe<SanityStoreAddress>;
  
  readonly storeNumber?: Maybe<string>;
  
  readonly storeStatus?: Maybe<StoreStatus>;
  
  readonly timezone?: Maybe<string>;
}


export interface StoreAddress {
  
  readonly addressLine1: string;
  
  readonly addressLine2?: Maybe<string>;
  
  readonly city?: Maybe<string>;
  
  readonly country: string;
  
  readonly state?: Maybe<string>;
  
  readonly zip: string;
}


export interface StoreDetails {
  
  readonly amenities?: Maybe<ReadonlyArray<Maybe<IRestaurantAmenity>>>;
  
  readonly deliveryHours?: Maybe<StoreHours>;
  
  readonly diningRoomHours?: Maybe<StoreHours>;
  
  readonly driveThruHours?: Maybe<StoreHours>;
  
  readonly franchiseGroupId?: Maybe<number>;
  
  readonly franchiseGroupName?: Maybe<string>;
  
  readonly hasCatering?: Maybe<boolean>;
  
  readonly hasDelivery?: Maybe<boolean>;
  
  readonly hasDineIn?: Maybe<boolean>;
  
  readonly hasDriveThru?: Maybe<boolean>;
  
  readonly hasMobileOrdering?: Maybe<boolean>;
  /** Last date time when the store made an order */
  readonly lastActiveDateTime?: Maybe<string>;
  
  readonly latitude?: Maybe<number>;
  
  readonly longitude?: Maybe<number>;
  
  readonly mobileOrderingStatus?: Maybe<string>;
  
  readonly phoneNumber?: Maybe<string>;
  
  readonly posVendor?: Maybe<string>;
  
  readonly status?: Maybe<string>;
  
  readonly storeNumber?: Maybe<string>;
  
  readonly timezone?: Maybe<string>;
}


export interface StoreHours {
  
  readonly friday?: Maybe<Day>;
  
  readonly monday?: Maybe<Day>;
  
  readonly saturday?: Maybe<Day>;
  
  readonly sunday?: Maybe<Day>;
  
  readonly thursday?: Maybe<Day>;
  
  readonly tuesday?: Maybe<Day>;
  
  readonly wednesday?: Maybe<Day>;
}


export interface StoreStatus {
  
  readonly posVendor?: Maybe<string>;
  
  readonly region: string;
  
  readonly statuses: StoreStatuses;
  
  readonly storeId: string;
}


export interface StoreStatuses {
  
  readonly app?: Maybe<StatusesApp>;
  
  readonly doordash?: Maybe<StatusesApp>;
  
  readonly grubhub?: Maybe<StatusesApp>;
  
  readonly uber?: Maybe<StatusesApp>;
}


export interface Summary {
  /** gift card last 4 digits */
  readonly alias: string;
  /** dollar amount gift card begins with */
  readonly beginBalance: number;
  
  readonly currencyCode: string;
  /** current gift card balance in cents */
  readonly currentBalance: number;
  /** Two digit expiry month */
  readonly expiryMonth: string;
  /** Two digit expiry year */
  readonly expiryYear: string;
  /** First Data Correlation ID */
  readonly fdCorrelationId: string;
  /** First Data prepaid status */
  readonly status: string;
}


export interface Transaction {
  
  readonly amount: number;
  
  readonly currencyCode?: Maybe<string>;
  
  readonly currencyCodeNumeric?: Maybe<number>;
  
  readonly info?: Maybe<string>;
  
  readonly transactionTime?: Maybe<string>;
}


export interface TransactionOrders {
  
  readonly couponId?: Maybe<string>;
  
  readonly incentivePlu?: Maybe<string>;
  
  readonly lineId?: Maybe<string>;
  
  readonly name?: Maybe<string>;
  
  readonly parentReferenceId?: Maybe<string>;
  
  readonly plu?: Maybe<string>;
  
  readonly pluDocuments?: Maybe<ReadonlyArray<Maybe<PluDocument>>>;
  
  readonly posVendor?: Maybe<string>;
  
  readonly price?: Maybe<string>;
  
  readonly productId?: Maybe<string>;
  
  readonly productType?: Maybe<string>;
  
  readonly quantity?: Maybe<string>;
  
  readonly tax?: Maybe<string>;
}


export interface UnavailableCartEntry {
  
  readonly lineId?: Maybe<string>;
  
  readonly sanityId: string;
}


export interface UpdateDobResponse {
  
  readonly customerId: string;
  
  readonly dob?: Maybe<string>;
}


export interface UserDetails {
  
  readonly createdAt?: Maybe<string>;
  
  readonly dob?: Maybe<string>;
  
  readonly email?: Maybe<string>;
  
  readonly isoCountryCode?: Maybe<string>;
  
  readonly name?: Maybe<string>;
  
  readonly phoneNumber?: Maybe<string>;
  
  readonly promotionalEmails?: Maybe<string>;
  
  readonly userId?: Maybe<string>;
  
  readonly zip?: Maybe<string>;
}


export interface VendorConfig {
  
  readonly constantPlu?: Maybe<string>;
  
  readonly multiConstantPlus?: Maybe<ReadonlyArray<Maybe<QuantityPlu>>>;
  
  readonly parentChildPlu?: Maybe<ParentChildPlu>;
  
  readonly parentSanityId?: Maybe<string>;
  
  readonly pluType: string;
  
  readonly pullUpLevels?: Maybe<number>;
  
  readonly quantityBasedPlu?: Maybe<ReadonlyArray<Maybe<QuantityPlu>>>;
  
  readonly sizeBasedPlu?: Maybe<SizeBasedPlu>;
}


export interface VendorConfigs {
  
  readonly carrols?: Maybe<VendorConfig>;
  
  readonly carrolsDelivery?: Maybe<VendorConfig>;
  
  readonly ncr?: Maybe<VendorConfig>;
  
  readonly ncrDelivery?: Maybe<VendorConfig>;
  
  readonly productNumber?: Maybe<VendorConfig>;
  
  readonly sicom?: Maybe<VendorConfig>;
  
  readonly sicomDelivery?: Maybe<VendorConfig>;
}



// ====================================================
// Arguments
// ====================================================

export interface OrdersCustomerArgs {
  
  createdAfter?: Maybe<string>;
  
  createdBefore?: Maybe<string>;
  
  limit?: Maybe<number>;
  
  orderStatuses?: Maybe<ReadonlyArray<Maybe<RbiOrderStatus>>>;
  
  resumeAfter?: Maybe<string>;
  
  sortAscending?: Maybe<boolean>;
}
export interface AssignedOffersCustomerDetailsArgs {
  
  offersVersion?: Maybe<string>;
  
  resumeAfter?: Maybe<string>;
}
export interface CouponRedemptionsCustomerDetailsArgs {
  
  resumeAfter?: Maybe<string>;
}
export interface CouponTokensCustomerDetailsArgs {
  
  resumeAfter?: Maybe<string>;
}
export interface OrdersCustomerDetailsArgs {
  
  createdAfter?: Maybe<string>;
  
  createdBefore?: Maybe<string>;
  
  limit?: Maybe<number>;
  
  orderStatuses?: Maybe<ReadonlyArray<Maybe<RbiOrderStatus>>>;
  
  resumeAfter?: Maybe<string>;
  
  sortAscending?: Maybe<boolean>;
}
export interface OrdersByIdsCustomerDetailsArgs {
  
  orderIds: ReadonlyArray<Maybe<string>>;
}
export interface RemediationsCustomerDetailsArgs {
  
  resumeAfter?: Maybe<string>;
}
export interface SupportOffersCustomerDetailsArgs {
  
  offersVersion?: Maybe<string>;
}
export interface CtgLoyaltyCreatePersonalizedOfferMutationArgs {
  
  agentEmail?: Maybe<string>;
  
  cognitoId: string;
  
  comments?: Maybe<string>;
  
  loyaltyId: string;
  
  metadata?: Maybe<ReadonlyArray<CtgLoyaltyMetadataEntryInput>>;
  
  offerConfigId: string;
  
  offerTemplateId: string;
  
  orderId?: Maybe<string>;
  
  reason: string;
  
  refundedItems?: Maybe<ReadonlyArray<Maybe<RefundedItemsInput>>>;
}
export interface CtgLoyaltyDeductPointsMutationArgs {
  
  comments?: Maybe<string>;
  
  loyaltyId: string;
  
  loyaltyUserCognitoId: string;
  
  metadata?: Maybe<ReadonlyArray<CtgLoyaltyMetadataEntryInput>>;
  
  orderId?: Maybe<string>;
  
  points: number;
  
  reason: string;
}
export interface CtgLoyaltyIssuePointsMutationArgs {
  
  comments?: Maybe<string>;
  
  loyaltyId: string;
  
  loyaltyUserCognitoId: string;
  
  metadata?: Maybe<ReadonlyArray<CtgLoyaltyMetadataEntryInput>>;
  
  orderId?: Maybe<string>;
  
  points: number;
  
  reason: string;
  
  refundedItems?: Maybe<ReadonlyArray<Maybe<RefundedItemsInput>>>;
}
export interface CtgLoyaltyRemoveSecondaryIdentifierMutationArgs {
  
  identifier: string;
  
  identifierType: string;
  
  loyaltyId: string;
}
export interface CtgLoyaltyWalmartUserUnlinkMutationArgs {
  
  loyaltyId: string;
}
export interface CustomerSignUpMutationArgs {
  
  accountType?: Maybe<string>;
  
  country: string;
  
  customerIp: string;
  
  dob?: Maybe<string>;
  
  forterMobileUID?: Maybe<string>;
  
  forterTokenCookie?: Maybe<string>;
  
  name?: Maybe<string>;
  
  phoneNumber?: Maybe<string>;
  
  userAgent: string;
  
  userName: string;
  
  wantsPromotionalEmails?: Maybe<boolean>;
  
  zipCode?: Maybe<string>;
}
export interface IssueCouponToUserMutationArgs {
  /** Brief description on the situation that caused coupon to be issued This is optional. */
  comments?: Maybe<string>;
  /** How many coupons to create */
  count?: Maybe<number>;
  /** The identity of the coupon to redeem. This is required. */
  couponId: string;
  /** The ISO-formatted timestamp of when the coupon token expires. If the value is null, then the coupon token never expires. This is optional. */
  expiresOn?: Maybe<string>;
  /** Reason for issuing the coupon This is optional */
  reason?: Maybe<string>;
  /** The id of order that was refunded */
  refundedRbiOrderId?: Maybe<string>;
  /** The identity of the user the coupon token is being assigned to. This is required */
  userId: string;
}
export interface PrepaidsMergeMutationArgs {
  
  input: PrepaidsMergeInput;
}
export interface PrepaidsReplaceMutationArgs {
  
  input: PrepaidsReplaceInput;
}
export interface RecordNonRemediationMutationArgs {
  
  customerId: string;
  
  orderId: string;
  
  remediationComment: string;
  
  remediationReason: string;
}
export interface RefundSaleMutationArgs {
  
  input: RefundSaleInput;
}
export interface RemoveEmailFromBounceListIfExistMutationArgs {
  
  input: RemoveEmailFromBounceListIfExistInput;
}
export interface UpdateCommunicationPreferencesMutationArgs {
  
  input: UpdateCommunicationPreferencesInput;
}
export interface UpdateDobMutationArgs {
  
  customerId: string;
  
  dob: string;
}
export interface CustomerQueryArgs {
  
  customerId?: Maybe<string>;
  
  email?: Maybe<string>;
  
  resumeAfter?: Maybe<string>;
}
export interface LaunchDarklyFlagQueryArgs {
  
  country: string;
  
  customContext?: Maybe<Json>;
  
  customerId: string;
  
  flagName: string;
}
export interface OrderQueryArgs {
  
  rbiOrderId: string;
}
export interface CtgLoyaltyIdByEmailQueryArgs {
  
  email: string;
}
export interface CtgLoyaltyOffersByLoyaltyIdQueryArgs {
  
  loyaltyId: string;
}
export interface CtgLoyaltyQuestsByLoyaltyIdQueryArgs {
  
  loyaltyId: string;
}
export interface CtgLoyaltyTransactionQueryArgs {
  
  loyaltyId: string;
  
  shortId: string;
}
export interface CtgLoyaltyTransactionByIdQueryArgs {
  
  id: string;
}
export interface CtgLoyaltyTransactionsQueryArgs {
  
  loyaltyId: string;
  
  resumeAfter?: Maybe<string>;
}
export interface CtgLoyaltyUserByIdQueryArgs {
  
  loyaltyId: string;
}
export interface CtgRbiOrderIdsByTransactionIdsQueryArgs {
  
  loyaltyId: string;
  
  transactionIds: ReadonlyArray<string>;
}
export interface CustomerByEmailQueryArgs {
  
  email: string;
}
export interface CustomersByDeviceIdQueryArgs {
  
  deviceId: string;
}
export interface DsarRequestQueryArgs {
  
  dsarRequestId: string;
  
  requestType?: Maybe<string>;
}
export interface DsarRequestsQueryArgs {
  
  fromDate?: Maybe<string>;
  
  nextPage?: Maybe<string>;
  
  requestStatus?: Maybe<string>;
  
  requestType?: Maybe<string>;
  
  toDate?: Maybe<string>;
}
export interface IsEmailInBounceListQueryArgs {
  
  input: IsEmailInBounceListInput;
}
export interface OrdersQueryArgs {
  
  createdAfter?: Maybe<string>;
  
  createdBefore?: Maybe<string>;
  
  email: string;
  
  limit?: Maybe<number>;
  
  orderStatuses?: Maybe<ReadonlyArray<Maybe<RbiOrderStatus>>>;
  
  resumeAfter?: Maybe<string>;
  
  sortAscending?: Maybe<boolean>;
}
export interface PrepaidByCardNumberQueryArgs {
  
  cardNumber: string;
  
  isoCountryCode: string;
}
export interface PrepaidByCustomerQueryArgs {
  
  email: string;
}
export interface PrepaidDetailQueryArgs {
  
  cardNumber: string;
  
  email: string;
}
export interface PrepaidSummaryQueryArgs {
  
  cardNumber: string;
  
  isoCountryCode: string;
}
export interface StoreQueryArgs {
  
  storeId: string;
}
export interface StoreMenuArtifactsMetadataQueryArgs {
  
  region: string;
  
  storeId: string;
}
export interface StoresQueryArgs {
  
  searchTerm: string;
}


